"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Driver = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Driver = function Driver(_ref) {
  var tour = _ref.tour;
  var _tour$driver = tour.driver,
      driver = _tour$driver === void 0 ? {} : _tour$driver;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-0 px-1 pb-1"
  }, driver.firstName && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.firstName",
    tagName: "span"
  }), ": ", driver.firstName), driver.lastName && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.lastName",
    tagName: "span"
  }), ": ", driver.lastName), driver.phoneNumber && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.telephone",
    tagName: "span"
  }), ": ", driver.phoneNumber));
};

exports.Driver = Driver;
Driver.propTypes = {
  tour: _propTypes["default"].shape({
    driver: _propTypes["default"].shape({
      firstName: _propTypes["default"].string,
      lastName: _propTypes["default"].string,
      phoneNumber: _propTypes["default"].string
    })
  }).isRequired
};
Driver.defaultProps = {};
var _default = Driver;
exports["default"] = _default;